import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({ theme: "clean", toggle: () => {} });

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const q = params.get("theme");
    if (["warm", "clean", "midnight", "sage"].includes(q)) return q;
    return localStorage.getItem("md-theme") || "clean";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("md-theme", theme);
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "clean" ? "warm" : "clean"));

  return (
    <ThemeContext.Provider value={{ theme, toggle }}>{children}</ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
